import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Projeler from "../pages/projeler/page";
import ProjeDetay from "../pages/proje-detay/page";
import StudyoAsimMete from "../pages/studyo-asim-mete/page";
import GravitasLibera from "../pages/gravitas-libera/page";
import Iletisim from "../pages/iletisim/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/projeler",
    element: <Projeler />,
  },
  {
    path: "/proje/:id",
    element: <ProjeDetay />,
  },
  {
    path: "/studyo-asim-mete",
    element: <StudyoAsimMete />,
  },
  {
    path: "/gravitas-libera",
    element: <GravitasLibera />,
  },
  {
    path: "/iletisim",
    element: <Iletisim />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;